import * as React from 'react';
import { Alert } from 'reactstrap';
import { CheckInputField } from '../../../components/Forms/fields/CheckInputField';
import { WaitingListSettingsData } from '../../../models';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { SettingsItemContentProps } from '../SettingsItem';

interface WaitingListSettingsProps extends SettingsItemContentProps {
    values: WaitingListSettingsData;
    onChange: (settings: WaitingListSettingsData) => void;
}

const WaitingListSettings: React.FC<WaitingListSettingsProps> = ({ values, onChange }) => {
    const t = useTranslations();

    const handleRemoveFromWaitingListChange = React.useCallback((removeFromWaitingListWhenAppointmentCreated: boolean) => {
        onChange({
            ...values,
            removeFromWaitingListWhenAppointmentCreated,
        });
    }, [onChange, values]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacer-S)' }}>
            <Alert color="secondary" isOpen>
                {t(TK.waitingListSettingsDescription)}
            </Alert>

            <CheckInputField
                id="waiting-list-remove-after-appointment-created"
                label={t(TK.removeFromWaitingListWhenAppointmentCreated)}
                helpText={t(TK.removeFromWaitingListWhenAppointmentCreatedHelp)}
                value={values.removeFromWaitingListWhenAppointmentCreated}
                onChange={handleRemoveFromWaitingListChange}
            />
        </div>
    );
};

export default WaitingListSettings;
